import { render, staticRenderFns } from "./topindicators.vue?vue&type=template&id=09153f4b&"
import script from "./topindicators.vue?vue&type=script&lang=js&"
export * from "./topindicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports